import React, { Component } from 'react'
import {
  ListItemText,
  Checkbox,
  withStyles,
  ListItem
} from '@material-ui/core'
import {
  PrestazioniNuoveIcon,
  PrestazioniCDIcon,
  PrestazioniMeccanicaIcon,
  PrestazioniRevisioneIcon
} from '../atoms/PrestazioniIcons'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  icon: {
    border: '1px solid',
    borderRadius: 4
  }
})

const itemColors = {
  meccanica: '#ffeb3b',
  revisione: '#e53935',
  pneumatici_nuovi: '#43a047',
  pneumatici_cd: '#303f9f',
  pneumatici_cliente: '#209f6f'
}

const itemIcons = {
  meccanica: PrestazioniMeccanicaIcon,
  revisione: PrestazioniRevisioneIcon,
  pneumatici_nuovi: PrestazioniNuoveIcon,
  pneumatici_cd: PrestazioniCDIcon,
  pneumatici_cliente: PrestazioniCDIcon
}

// This component is added to prevent a crash for the a non existent category
const NoIcon = () => <div/>

export class ServiceItemBase extends Component {
  handleOnChange = () => {
    const { service, selected, onChange } = this.props
    onChange(service, !selected)
  }

  getIcon = serviceType => itemIcons[serviceType] || NoIcon

  getColor = serviceType => itemColors[serviceType] || '#cccccc'

  render() {
    const { classes, service, selected } = this.props
    const Icon = this.getIcon(service.tipoWeb)
    return (
      <ListItem onClick={this.handleOnChange} className={classes.root}>
        <Icon
          nativeColor={this.getColor(service.tipoWeb)}
          fontSize="large"
          className={classes.icon}
        />
        <ListItemText primary={service.descrizione} secondary={service.descrizioneAggiuntiva} />
        <Checkbox checked={selected} color="primary" />
      </ListItem>
    )
  }
}

export const ServiceItem = withStyles(styles)(ServiceItemBase)
